"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var jss_1 = __importDefault(require("jss"));
var jss_plugin_global_1 = __importDefault(require("jss-plugin-global"));
var Animation_1 = __importDefault(require("./classes/Animation"));
var Border_1 = __importDefault(require("./classes/Border"));
var Color_1 = __importDefault(require("./classes/Color"));
var Flex_1 = __importDefault(require("./classes/Flex"));
var Handy_1 = __importDefault(require("./classes/Handy"));
var MarginPadding_1 = __importDefault(require("./classes/MarginPadding"));
var Opacity_1 = __importDefault(require("./classes/Opacity"));
var Positional_1 = __importDefault(require("./classes/Positional"));
var Shadow_1 = __importDefault(require("./classes/Shadow"));
var Transform_1 = __importDefault(require("./classes/Transform"));
var TextAlignment_1 = __importDefault(require("./classes/TextAlignment"));
jss_1.default.use(jss_plugin_global_1.default());
function useClasses(theme) {
    return styles_1.makeStyles(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({ 
        /* make sure the headers & font matches what we told MUI */
        "@global": {
            body: {
                fontFamily: theme.typography.fontFamily
            },
            h1: __assign(__assign({}, theme.typography.h1), { margin: 0 }),
            h2: __assign(__assign({}, theme.typography.h2), { margin: 0 }),
            h3: __assign(__assign({}, theme.typography.h3), { margin: 0 }),
            h4: __assign(__assign({}, theme.typography.h4), { margin: 0 }),
            h5: __assign(__assign({}, theme.typography.h5), { margin: 0 }),
            h6: __assign(__assign({}, theme.typography.h6), { margin: 0 }),
            "::-webkit-scrollbar-button": { display: "none" },
            "::-webkit-scrollbar-thumb": {
                backgroundColor: theme.palette.primary.main,
                borderRadius: 8,
                border: "4px solid rgba(0, 0, 0, 0)",
                backgroundClip: "padding-box"
            },
            "::-webkit-scrollbar-thumb:hover": { backgroundColor: theme.palette.primary.dark },
            "::-webkit-scrollbar-track": { display: "none" },
            "::-webkit-scrollbar": { width: 16, height: 16 }
        } }, Border_1.default()), Color_1.default(theme.palette)), Flex_1.default()), Handy_1.default()), MarginPadding_1.default(theme.spacing)), Opacity_1.default()), Positional_1.default()), TextAlignment_1.default()), Shadow_1.default()), Animation_1.default()), Transform_1.default()));
}
exports.useClasses = useClasses;
//# sourceMappingURL=index.js.map